<template>
  <div>
    <div class="video-box">
      <div v-if="isShow" class="poster-img" :style="`background-image: url(${videoData.poster});`"></div>  
      <div class="video-modal text-center" :class="isShow?'':'close-modal'">
        <div v-if="isShow" v-html="videoData.content?videoData.content:''"></div>
        <!-- 加上style设置关闭的按钮大小，因为有时候视频太小的位置，按钮占屏幕太多 -->
        <span class="iconfont cursor-pointer" :style="!isShow&&videoData.closeFontSize?`font-size: ${videoData.closeFontSize};`:''" :class="classList[currClass]" @mouseover="changeIcon(1)" @mouseleave="changeIcon(0)" @click="changeStatus"></span>
      </div>
      <video :width="videoData.width?videoData.width:'100%'" :height="videoData.height" :ref="videoData.ref" controls>
        <source :src="videoData.linkUrl" type="video/mp4">
        <!-- <source src="https://www.runoob.com/try/demo_source/movie.ogg" type="video/ogg"> -->
      </video>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    videoData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isPlay: false,
      currClass: 0,
      classList: ['iconpause', 'iconbofang1', 'iconguanbi1', 'iconguanbi'], 
      isShow: true,
      
    }
  },
  methods: {
    changeIcon(type) {
      if(!this.isPlay) {
        this.currClass = type;
      }else {
        this.currClass = type==1?3:2
      }
    },
    changeStatus() {
      this.isPlay = !this.isPlay;
      if(this.isPlay) {
        this.currClass = 2;
        this.$refs[this.videoData.ref].play();
        this.isShow = false;
      }else {
        this.currClass = 0;
        // this.$refs[this.videoData.ref].pause(); //暂停
        this.$refs[this.videoData.ref].load(); //重载
        this.isShow = true;
      }
    }
  },
  mounted () {
    // console.log(this.videoData)
  }
}
</script>
<style lang="scss" scoped>
.video-box {
  position: relative;
  .poster-img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
    width:100%;
    height: 100%;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;
  }
  .video-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    z-index: 999;
    .iconfont {
      color: #fff;
      font-size: 72PX;
    }
    // .sm-text {
    //   font-size: 24PX;
    // }
    // .lg-text {
    //   margin: 24PX 0 64PX;
    //   font-size: 48PX;
    //   font-family: none;
    // }
    &.close-modal {
      left: initial;
      right: 20PX;
      top: 20PX;
      transform: translate(0);
      .iconfont {
        color: #333;
      }
    }
  }
}
</style>